<template>
    <div class="content">
        <h3 ref="pageHeader" class="pageHeader">安全承诺书管理</h3>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
                <el-form-item label="组织结构">
                    <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell"
                        @handleOrganQuery="handleOrganQuery1">
                    </OrganDialog>
                    <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
                        @clear="handeleClear1" clearable></el-input>
                </el-form-item>
                <el-form-item label="签字状态">
                    <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
                        <el-option label="未签署" value="0"></el-option>
                        <el-option label="已签署" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学生姓名">
                    <el-input v-model="formInline.student_name" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="学号">
                    <el-input v-model="formInline.student_number" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleQuery">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <custom-table :data="tableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column prop="student_name" label="学生姓名">
                </custom-table-column>
                <custom-table-column prop="number" label="学号">
                </custom-table-column>
                <custom-table-column prop="status" label="签字状态">
                </custom-table-column>
                <custom-table-column prop="signed_at" label="签字时间">
                </custom-table-column>
                <custom-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status == '已签署' && scope.row.signature_url"
                            @click="handleDownload(scope.row.signature_url)" type="text" size="small">下载</el-button>
                        <el-button v-if="scope.row.status == '已签署'" @click="handleView('view', scope.row.student_id)"
                            type="text" size="small">预览</el-button>
                        <!-- <el-button v-else @click="handleView('sign')" type="text" size="small">签字</el-button> -->
                    </template>
                </custom-table-column>
            </custom-table>
            <div class="pageLine">
                <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="安全承诺书" :visible.sync="detailDialogVisible" width="706px" destroy-on-close>
            <CommitmentSign ref="sign" :signType="signType" :studentId="studentId"></CommitmentSign>
        </el-dialog>
    </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import CommitmentSign from './commitmentSign.vue'

export default {
    name: 'trainingRoom',
    mixins: [mixinList, mixinOrgan],
    data() {
        return {
            formInline: {
                structure_1: '',
                structure_2: '',
                status: '',
                student_name: '',
                student_number: '',
            },
            detailDialogVisible: false,
            levell: [1, 2, 3],
            centerDialogVisible: false,
            total: 0,
            tableData: [],
            studentId: '',
            signType: 'view'
        };
    },
    components: {
        CommitmentSign
    },
    created() {
    },
    mounted() {
    },
    methods: {
        handleView(status, sid) {
            this.signType = status;
            this.studentId = sid;
            this.detailDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.sign.getPdfFile()
            });
        },
        handleDownload(url) {
            location.href = url;
        },
        handleQuery() {
            this.beforeQueryByKeyNew({ major: "structure_2", cls: 'class_name' });
            this.$refs.pageChild.page = 1;
            this.getList();
        },

        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/safety_commitment/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
    width: var(--width);
}
</style>
